<dx-popup
  [visible]="visible"
  [position]="position"
  [width]="width ? width : 550"
  [height]="height ? height : 'auto'"
  [maxHeight]="'96vh'"
  [minHeight]="200"
  [animation]="animation"
  [resizeEnabled]="true"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [fullScreen]="isFullScreen"
  (onHiding)="onHiding()"
  [toolbarItems]="toolbarItems"

>
  <div *dxTemplate="let data of 'title'" style="padding: 0px">
    <!-- DKM-5192 Cedric: eski hâli — [displayEditBtn]="displayEditBtn"; otomatikDuzenle açıkken Düzenle düğmesi gizlenir -->
    <dk-popup-header
      [isShowCancelButton]="isShowCancelButton"
      [state]="state"
      [width]="width"
      [formMetada]="formMetada"
      [visible]="visible"
      [title]="title"
      [displayEditBtn]="duzenleDugmesiGorunur"
      (visibleChange)="visibleChange.emit($event)"
      (editModeChange)="editModeChange.emit($event)"
      [dynamicButtons]="dynamicButtons"
      (dynamicButtonClicked)="dynamicButtonClicked.emit($event)"
      [maximizable]="maximizable"
      [(isFullScreen)]="isFullScreen"
    >
    </dk-popup-header>
  </div>

  <div *dxTemplate="let data of 'content'"  style="overflow: auto">
    <ng-content  ></ng-content>
  </div>
  <div *dxTemplate="let data of 'bottom'" style="overflow: auto">
    <dk-popup-footer
      [formName]="popupName"
      [errorResponse]="errorResponse"
      [state]="state"
      [formAction]="state"
    ></dk-popup-footer>
  </div>
</dx-popup>
